import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useCallback } from 'react';
import { CURRENCY_FMTS, GENERAL_FMT, NUMBER_FMTS, PERCENT_FMT } from '@/config/spreadsheet';
import { MAX_DECIMAL_LENGTH, isPatternHasDecimal } from '@/common/utils/spreadsheetFormat';

var DecimalLeftIcon = function DecimalLeftIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.72913 1.47852C5.46303 1.47852 4.3208 2.41771 4.3208 3.71195V6.90382C4.3208 8.19804 5.46303 9.13725 6.72913 9.13725C7.99522 9.13725 9.13746 8.19804 9.13746 6.90382V3.71195C9.13746 2.41771 7.99522 1.47852 6.72913 1.47852ZM5.5958 3.71195C5.5958 3.24337 6.03923 2.75352 6.72913 2.75352C7.41903 2.75352 7.86246 3.24337 7.86246 3.71195V6.90382C7.86246 7.37239 7.41903 7.86225 6.72913 7.86225C6.03923 7.86225 5.5958 7.37239 5.5958 6.90382V3.71195Z",
      fill: "#3A3D4D"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.40336 10.1382C8.65233 9.88928 9.05597 9.88928 9.30492 10.1382C9.55389 10.3872 9.55389 10.7908 9.30492 11.0398L8.26821 12.0766H14.8748C15.2269 12.0766 15.5123 12.3619 15.5123 12.7141C15.5123 13.0661 15.2269 13.3516 14.8748 13.3516H8.26821L9.30492 14.3882C9.55389 14.6372 9.55389 15.0408 9.30492 15.2898C9.05597 15.5387 8.65233 15.5387 8.40336 15.2898L6.28714 13.1736C6.16653 13.0576 6.09148 12.8946 6.09148 12.7141C6.09148 12.5334 6.16653 12.3704 6.28714 12.2544L8.40336 10.1382ZM1.4873 8.81914C1.4873 8.46705 1.77272 8.18164 2.1248 8.18164H2.47898C2.83106 8.18164 3.11648 8.46705 3.11648 8.81914C3.11648 9.17122 2.83106 9.45664 2.47898 9.45664H2.1248C1.77272 9.45664 1.4873 9.17122 1.4873 8.81914Z",
      fill: "#3A3D4D"
    })]
  }));
};

DecimalLeftIcon.defaultProps = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var DecimalRightIcon = function DecimalRightIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.06641 3.99366C4.06641 2.77555 5.14145 1.8916 6.33307 1.8916C7.52469 1.8916 8.59974 2.77555 8.59974 3.99366V6.99777C8.59974 8.21586 7.52469 9.09982 6.33307 9.09982C5.14145 9.09982 4.06641 8.21586 4.06641 6.99777V3.99366ZM6.33307 3.0916C5.68376 3.0916 5.26641 3.55264 5.26641 3.99366V6.99777C5.26641 7.43878 5.68376 7.89982 6.33307 7.89982C6.98239 7.89982 7.39974 7.43878 7.39974 6.99777V3.99366C7.39974 3.55264 6.98239 3.0916 6.33307 3.0916ZM10.0664 3.99366C10.0664 2.77555 11.1415 1.8916 12.3331 1.8916C13.5247 1.8916 14.5997 2.77555 14.5997 3.99366V6.99777C14.5997 8.21586 13.5247 9.09982 12.3331 9.09982C11.1415 9.09982 10.0664 8.21586 10.0664 6.99777V3.99366ZM12.3331 3.0916C11.6838 3.0916 11.2664 3.55264 11.2664 3.99366V6.99777C11.2664 7.43878 11.6838 7.89982 12.3331 7.89982C12.9824 7.89982 13.3997 7.43878 13.3997 6.99777V3.99366C13.3997 3.55264 12.9824 3.0916 12.3331 3.0916Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.4242 10.0417C12.1899 9.80739 11.81 9.80739 11.5756 10.0417C11.3413 10.276 11.3413 10.6559 11.5756 10.8902L12.5514 11.866H6.3334C6.00203 11.866 5.7334 12.1346 5.7334 12.466C5.7334 12.7973 6.00203 13.066 6.3334 13.066H12.5514L11.5756 14.0417C11.3413 14.276 11.3413 14.6559 11.5756 14.8902C11.81 15.1245 12.1899 15.1245 12.4242 14.8902L14.4159 12.8985C14.5294 12.7893 14.6001 12.6359 14.6001 12.466C14.6001 12.296 14.5294 12.1426 14.4159 12.0334L12.4242 10.0417ZM1.3999 8.8002C1.3999 8.46882 1.66853 8.2002 1.9999 8.2002H2.33324C2.66461 8.2002 2.93324 8.46882 2.93324 8.8002C2.93324 9.13157 2.66461 9.4002 2.33324 9.4002H1.9999C1.66853 9.4002 1.3999 9.13157 1.3999 8.8002Z",
      fill: "#12131A"
    })]
  }));
};

DecimalRightIcon.defaultProps = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var DownChevron = function DownChevron(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7071 0.292986C11.3166 -0.097538 10.6834 -0.097538 10.2929 0.292986L6 4.58588L1.70711 0.292986C1.31658 -0.0975381 0.683417 -0.0975381 0.292893 0.292986C-0.0976314 0.68351 -0.0976314 1.31668 0.292893 1.7072L6 7.41431L11.7071 1.7072C12.0976 1.31668 12.0976 0.68351 11.7071 0.292986Z",
      fill: "#12131A"
    })
  }));
};

DownChevron.defaultProps = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var TextIcon = function TextIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.33329 2C2.9651 2 2.66663 2.29848 2.66663 2.66667V4.66667C2.66663 5.03486 2.9651 5.33333 3.33329 5.33333C3.70148 5.33333 3.99996 5.03486 3.99996 4.66667V3.33333H7.33329V12.6667H5.33329C4.9651 12.6667 4.66663 12.9651 4.66663 13.3333C4.66663 13.7015 4.9651 14 5.33329 14H10.6666C11.0348 14 11.3333 13.7015 11.3333 13.3333C11.3333 12.9651 11.0348 12.6667 10.6666 12.6667H8.66663V3.33333H12V4.66667C12 5.03486 12.2984 5.33333 12.6666 5.33333C13.0348 5.33333 13.3333 5.03486 13.3333 4.66667V2.66667C13.3333 2.29848 13.0348 2 12.6666 2H3.33329Z",
      fill: "black"
    })
  }));
};

TextIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var SettingsIcon = function SettingsIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 2C13.1894 2 13.8136 2.27905 14.2659 2.73036C14.2834 2.74784 14.3007 2.76559 14.3177 2.78358C14.7174 3.20678 14.971 3.76953 14.9977 4.39107L14.9985 4.41205C14.9995 4.44124 15 4.47056 15 4.5V4.51426C15 4.55491 15.0247 4.59145 15.0623 4.60702C15.0998 4.62261 15.1431 4.61423 15.1719 4.58546L15.182 4.57538C15.2028 4.55456 15.2239 4.53419 15.2452 4.51426L15.2607 4.5C15.719 4.07934 16.2962 3.86073 16.8782 3.84417C16.9029 3.84346 16.9277 3.84312 16.9524 3.84315C17.5913 3.84382 18.23 4.0879 18.7175 4.57538L19.4246 5.28249C19.9121 5.76997 20.1562 6.40868 20.1569 7.0476C20.1569 7.07234 20.1565 7.09709 20.1558 7.12182C20.1393 7.70375 19.9207 8.281 19.5 8.73935L19.4857 8.75476C19.4658 8.77611 19.4454 8.7972 19.4246 8.81802L19.4145 8.82811C19.3858 8.85687 19.3774 8.90017 19.393 8.93775C19.4085 8.97529 19.4451 9 19.4857 9H19.5C19.5294 9 19.5588 9.00051 19.5879 9.00152L19.6089 9.00233C20.2305 9.02898 20.7932 9.28257 21.2164 9.68233C21.2344 9.69933 21.2522 9.71659 21.2696 9.73411C21.721 10.1864 22 10.8106 22 11.5V12.5C22 13.1894 21.721 13.8136 21.2696 14.2659C21.2522 14.2834 21.2344 14.3007 21.2164 14.3177C20.7932 14.7174 20.2305 14.971 19.6089 14.9977L19.5879 14.9985C19.5588 14.9995 19.5294 15 19.5 15H19.4857C19.4451 15 19.4085 15.0247 19.393 15.0623C19.3774 15.0998 19.3858 15.1431 19.4145 15.1719L19.4246 15.182C19.4454 15.2028 19.4658 15.2239 19.4857 15.2452L19.5 15.2607C19.9207 15.719 20.1393 16.2962 20.1558 16.8782C20.1565 16.9029 20.1569 16.9277 20.1569 16.9524C20.1562 17.5913 19.9121 18.23 19.4246 18.7175L18.7175 19.4246C18.23 19.9121 17.5913 20.1562 16.9524 20.1568C16.9277 20.1569 16.9029 20.1565 16.8782 20.1558C16.2963 20.1393 15.719 19.9207 15.2607 19.5L15.2452 19.4857C15.2239 19.4658 15.2028 19.4454 15.182 19.4246L15.1719 19.4145C15.1431 19.3858 15.0998 19.3774 15.0623 19.393C15.0247 19.4085 15 19.4451 15 19.4857V19.5C15 19.5294 14.9995 19.5588 14.9985 19.5879L14.9977 19.6089C14.971 20.2305 14.7174 20.7932 14.3177 21.2164C14.3007 21.2344 14.2834 21.2522 14.2659 21.2696C13.8136 21.7209 13.1894 22 12.5 22H11.5C10.8106 22 10.1864 21.7209 9.73411 21.2696C9.71659 21.2522 9.69933 21.2344 9.68233 21.2164C9.28257 20.7932 9.02898 20.2305 9.00233 19.6089L9.00152 19.5879C9.00051 19.5588 9 19.5294 9 19.5V19.4857C9 19.4451 8.97529 19.4085 8.93774 19.393C8.90017 19.3774 8.85687 19.3858 8.8281 19.4145L8.81802 19.4246C8.7972 19.4454 8.77611 19.4658 8.75475 19.4857L8.73934 19.5C8.281 19.9207 7.70375 20.1393 7.12182 20.1558C7.09708 20.1565 7.07234 20.1569 7.0476 20.1568C6.40868 20.1562 5.76997 19.9121 5.28249 19.4246L4.57538 18.7175C4.0879 18.23 3.84382 17.5913 3.84315 16.9524C3.84312 16.9277 3.84346 16.9029 3.84417 16.8782C3.86073 16.2962 4.07934 15.719 4.5 15.2607L4.51426 15.2452C4.53419 15.2239 4.55456 15.2028 4.57538 15.182L4.58546 15.1719C4.61423 15.1431 4.62261 15.0998 4.60702 15.0623C4.59145 15.0247 4.55491 15 4.51426 15H4.5C4.47056 15 4.44125 14.9995 4.41205 14.9985L4.39107 14.9977C3.76953 14.971 3.20678 14.7174 2.78358 14.3177C2.76558 14.3007 2.74784 14.2834 2.73036 14.2659C2.27905 13.8136 2 13.1894 2 12.5V11.5C2 10.8106 2.27905 10.1864 2.73036 9.73411C2.74784 9.71659 2.76558 9.69933 2.78358 9.68233C3.20678 9.28257 3.76953 9.02898 4.39107 9.00233L4.41205 9.00152C4.44125 9.00051 4.47056 9 4.5 9H4.51426C4.55491 9 4.59145 8.97529 4.60702 8.93775C4.62261 8.90017 4.61423 8.85687 4.58546 8.82811L4.57538 8.81802C4.55456 8.7972 4.53419 8.77611 4.51426 8.75476L4.5 8.73935C4.07934 8.281 3.86073 7.70375 3.84417 7.12182C3.84346 7.09709 3.84312 7.07234 3.84315 7.0476C3.84382 6.40868 4.0879 5.76997 4.57538 5.28249L5.28249 4.57538C5.76997 4.0879 6.40868 3.84382 7.0476 3.84315C7.07234 3.84312 7.09709 3.84346 7.12182 3.84417C7.70375 3.86073 8.281 4.07934 8.73934 4.5L8.75476 4.51426C8.77611 4.53419 8.7972 4.55456 8.81802 4.57538L8.8281 4.58546C8.85687 4.61423 8.90017 4.62261 8.93775 4.60702C8.97529 4.59145 9 4.55491 9 4.51426V4.5C9 4.47056 9.00051 4.44124 9.00152 4.41205L9.00233 4.39107C9.02898 3.76953 9.28257 3.20678 9.68233 2.78358C9.69933 2.76559 9.71659 2.74784 9.73411 2.73036C10.1864 2.27905 10.8106 2 11.5 2H12.5ZM11 19.5C11 19.7761 11.2239 20 11.5 20H12.5C12.7761 20 13 19.7761 13 19.5V19.4857C13 18.6262 13.5212 17.8669 14.2962 17.5455C15.0727 17.2235 15.9787 17.3929 16.5861 18.0003L16.5962 18.0104C16.7915 18.2057 17.108 18.2057 17.3033 18.0104L18.0104 17.3033C18.2057 17.108 18.2057 16.7915 18.0104 16.5962L18.0003 16.5861C17.3929 15.9787 17.2235 15.0727 17.5455 14.2961C17.8669 13.5212 18.6262 13 19.4857 13H19.5C19.7761 13 20 12.7761 20 12.5V11.5C20 11.2239 19.7761 11 19.5 11H19.4857C18.6262 11 17.8669 10.4788 17.5455 9.70385C17.2235 8.92727 17.3929 8.02132 18.0003 7.41389L18.0104 7.40381C18.2057 7.20854 18.2057 6.89196 18.0104 6.6967L17.3033 5.98959C17.108 5.79433 16.7915 5.79433 16.5962 5.98959L16.5861 5.99968C15.9787 6.60711 15.0727 6.77651 14.2962 6.45448C13.5212 6.13311 13 5.37381 13 4.51426V4.5C13 4.22386 12.7761 4 12.5 4H11.5C11.2239 4 11 4.22386 11 4.5V4.51426C11 5.37381 10.4788 6.13311 9.70384 6.45448C8.92725 6.77651 8.02132 6.60711 7.41389 5.99968L7.40381 5.98959C7.20854 5.79433 6.89196 5.79433 6.6967 5.98959L5.98959 6.6967C5.79433 6.89196 5.79433 7.20854 5.98959 7.40381L5.99967 7.41389C6.60711 8.02132 6.77651 8.92727 6.45448 9.70385C6.13311 10.4788 5.37382 11 4.51426 11H4.5C4.22386 11 4 11.2239 4 11.5V12.5C4 12.7761 4.22386 13 4.5 13H4.51426C5.37382 13 6.13311 13.5212 6.45447 14.2961C6.77651 15.0727 6.60711 15.9787 5.99968 16.5861L5.98959 16.5962C5.79433 16.7915 5.79433 17.108 5.98959 17.3033L6.6967 18.0104C6.89196 18.2057 7.20854 18.2057 7.4038 18.0104L7.41389 18.0003C8.02132 17.3929 8.92726 17.2235 9.70384 17.5455C10.4788 17.8669 11 18.6262 11 19.4857V19.5Z",
      fill: "#515466"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
      fill: "#515466"
    })]
  }));
};

SettingsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.1548 0.488155C17.8057 -0.162718 18.861 -0.162718 19.5118 0.488155C20.1627 1.13903 20.1627 2.1943 19.5118 2.84518L12.357 10L19.5118 17.1548C20.1627 17.8057 20.1627 18.861 19.5118 19.5118C18.861 20.1627 17.8057 20.1627 17.1548 19.5118L10 12.357L2.84518 19.5118C2.1943 20.1627 1.13903 20.1627 0.488156 19.5118C-0.162719 18.861 -0.162719 17.8057 0.488156 17.1548L7.64298 10L0.488156 2.84518C-0.162718 2.1943 -0.162718 1.13903 0.488156 0.488155C1.13903 -0.162718 2.19431 -0.162718 2.84518 0.488155L10 7.64298L17.1548 0.488155Z",
      fill: "#BABDCC"
    })
  }));
};

CloseIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const EditorFormFieldsFormatControls = _ref => {
  let {
    className,
    editable,
    activeFormatValue,
    closestMatchFormat,
    isManualUpdate,
    onChange,
    onToggleManualUpdate,
    children
  } = _ref;
  const handleSelectChange = useCallback(evt => {
    const value = evt.target.value;

    if (value) {
      onChange(value);
      evt.target.selectedIndex = -1; // reset menu selection
    }
  }, [onChange]);
  const isCurrency = closestMatchFormat ? CURRENCY_FMTS.includes(closestMatchFormat) : false;
  const isPercent = closestMatchFormat ? PERCENT_FMT === closestMatchFormat : false;
  const isNumber = closestMatchFormat ? NUMBER_FMTS.includes(closestMatchFormat) : false;
  const isGeneral = closestMatchFormat ? GENERAL_FMT === closestMatchFormat : false;
  const isDecimal = Boolean(closestMatchFormat && isPatternHasDecimal((closestMatchFormat === null || closestMatchFormat === void 0 ? void 0 : closestMatchFormat.value) || ''));
  const isCustom = (closestMatchFormat || activeFormatValue) && !(isCurrency || isPercent || isNumber || isDecimal || isGeneral);
  return /*#__PURE__*/_jsxs("ul", {
    className: clsx(styles.container, className || ''),
    children: [/*#__PURE__*/_jsx("li", {
      className: clsx(styles.item, {
        [styles['item--active']]: isGeneral
      }),
      children: /*#__PURE__*/_jsx("button", {
        disabled: !editable,
        className: styles.button,
        type: "button",
        onClick: () => onChange(GENERAL_FMT.value),
        children: /*#__PURE__*/_jsx(TextIcon, {})
      })
    }), /*#__PURE__*/_jsxs("li", {
      className: clsx(styles.item, styles['item--hasMenu'], {
        [styles['item--active']]: isCurrency
      }),
      children: [/*#__PURE__*/_jsxs("button", {
        className: styles.button,
        type: "button",
        disabled: !editable,
        children: ["$", /*#__PURE__*/_jsx(DownChevron, {
          className: styles.button__chevron,
          viewBox: "0 0 12 8"
        })]
      }), /*#__PURE__*/_jsxs("select", {
        disabled: !editable,
        className: styles.item__menu,
        onChange: handleSelectChange,
        value: isCurrency && closestMatchFormat ? closestMatchFormat.value : '',
        children: [/*#__PURE__*/_jsx("option", {
          disabled: true,
          value: ""
        }), CURRENCY_FMTS.map((fmt, idx) => /*#__PURE__*/_jsx("option", {
          value: fmt.value,
          children: fmt.label
        }, `currencies-${fmt.value}-${idx}`))]
      })]
    }), /*#__PURE__*/_jsx("li", {
      className: clsx(styles.item, {
        [styles['item--active']]: isPercent
      }),
      children: /*#__PURE__*/_jsx("button", {
        disabled: !editable,
        className: styles.button,
        type: "button",
        onClick: () => onChange(PERCENT_FMT.value),
        children: PERCENT_FMT.label
      })
    }), /*#__PURE__*/_jsxs("li", {
      className: clsx(styles.item, styles['item--hasMenu'], {
        [styles['item--active']]: isNumber
      }),
      children: [/*#__PURE__*/_jsxs("button", {
        className: styles.button,
        type: "button",
        disabled: !editable,
        children: ["123", /*#__PURE__*/_jsx(DownChevron, {
          className: styles.button__chevron,
          viewBox: "0 0 12 8"
        })]
      }), /*#__PURE__*/_jsxs("select", {
        disabled: !editable,
        className: styles.item__menu,
        onChange: handleSelectChange,
        value: isNumber && closestMatchFormat ? closestMatchFormat.value : '',
        children: [/*#__PURE__*/_jsx("option", {
          disabled: true,
          value: ""
        }), NUMBER_FMTS.map((fmt, idx) => /*#__PURE__*/_jsx("option", {
          value: fmt.value,
          children: fmt.label
        }, `numbers-${fmt.value}-${idx}`))]
      })]
    }), typeof isManualUpdate === 'boolean' ? /*#__PURE__*/_jsx("li", {
      className: clsx(styles.item, {
        [styles['item--active']]: isCustom
      }),
      children: /*#__PURE__*/_jsx("button", {
        disabled: !editable,
        className: clsx(styles.button, clsx({
          [styles['button--focused']]: isManualUpdate
        })),
        type: "button",
        onClick: onToggleManualUpdate,
        children: /*#__PURE__*/_jsx(SettingsIcon, {
          className: styles.settingsIcon
        })
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("li", {
      className: styles.item,
      children: /*#__PURE__*/_jsx("button", {
        disabled: !editable,
        className: styles.button,
        type: "button",
        onClick: () => onChange(''),
        children: /*#__PURE__*/_jsx(CloseIcon, {
          className: styles.closeIcon
        })
      })
    }), children]
  });
};

const DecimalFormatControls = _ref2 => {
  let {
    className,
    editable,
    fixedDecimalLength,
    activeTrimDecimal,
    onEnableTrimDecimal,
    onChangeDecimal
  } = _ref2;
  return /*#__PURE__*/_jsxs("ul", {
    className: clsx(styles.container, className || ''),
    children: [/*#__PURE__*/_jsx("li", {
      className: clsx(styles.item, {
        [styles['item--active']]: activeTrimDecimal
      }),
      children: /*#__PURE__*/_jsx("button", {
        disabled: !editable,
        className: clsx(styles.button, styles['button--small']),
        type: "button",
        onClick: onEnableTrimDecimal,
        children: "Auto"
      })
    }), /*#__PURE__*/_jsx("li", {
      className: styles.item,
      children: /*#__PURE__*/_jsx("button", {
        disabled: !editable || !activeTrimDecimal && fixedDecimalLength < 1,
        className: styles.button,
        type: "button",
        onClick: () => onChangeDecimal(fixedDecimalLength < 1 ? 0 : fixedDecimalLength - 1),
        children: /*#__PURE__*/_jsx(DecimalLeftIcon, {})
      })
    }), /*#__PURE__*/_jsx("li", {
      className: styles.item,
      children: /*#__PURE__*/_jsx("button", {
        disabled: !editable || fixedDecimalLength === MAX_DECIMAL_LENGTH,
        className: styles.button,
        type: "button",
        onClick: () => onChangeDecimal(Math.max(1, fixedDecimalLength + 1)),
        children: /*#__PURE__*/_jsx(DecimalRightIcon, {})
      })
    }), !activeTrimDecimal ? /*#__PURE__*/_jsx("span", {
      className: styles.chip,
      children: Math.max(0, fixedDecimalLength)
    }) : null]
  });
};

export default EditorFormFieldsFormatControls;
export { styles, DecimalFormatControls };